import { FaRedo, FaWifi } from "react-icons/fa";

const OfflineState = ({ onRetry = () => window.location.reload(), className = "" }) => (
  <div className={`flex flex-col items-center justify-center text-center px-4 py-16 ${className}`}>
    <div className="w-20 h-20 rounded-full bg-error-container/50 flex items-center justify-center mx-auto mb-6 relative">
      <FaWifi className="text-error text-2xl rotate-45 opacity-80" />
      <span className="absolute inset-0 flex items-center justify-center">
        <span className="w-10 h-0.5 bg-error rotate-45 rounded" />
      </span>
    </div>
    <h2 className="text-xl font-bold text-on-primary-fixed-var mb-2">No internet connection</h2>
    <p className="text-sm text-on-surface-variant mb-8 max-w-xs leading-relaxed">
      Something went wrong. Please check your connection and try again.
    </p>
    <button
      type="button"
      onClick={onRetry}
      className="inline-flex items-center justify-center gap-2 bg-primary text-white px-8 py-2.5 rounded-full font-semibold text-sm hover:bg-primary-container transition-colors"
    >
      <FaRedo size={12} />
      Retry
    </button>
  </div>
);

export default OfflineState;
